import * as Actions from '../../actions/epicor/type';

const EpicorReducer = (state = {}, action) => {
  switch (action.type) {
    // ==============creating Ro  Epicor Jobs=========
    case Actions.CREATE_EPICOR_JOBS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.CREATE_EPICOR_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        epicorJobs: action.payload?.data || {},
      };
    case Actions.CREATE_EPICOR_JOBS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==============creating Estimator Epicor Jobs=========
    case Actions.CREATE_ESTMATOR_EPICOR_JOBS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.CREATE_ESTMATOR_EPICOR_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        estimatorEpiJobs: action.payload?.data || {},
      };
    case Actions.CREATE_ESTMATOR_EPICOR_JOBS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_ESTIMATOR_EPI_JOBS_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        estimatorEpiJobs: [],
      };

    default:
      return state;
  }
};

export default EpicorReducer;
